/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Folder_IdInputs */



/**
* | output |
* | --- |
* | "Folder Id" |
*
* @param {Folder_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const folder_id = /** @type {((inputs?: Folder_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Folder_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID du dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор папки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Id. de carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件夹 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID da pasta")
	return /** @type {LocalizedString} */ ("Folder Id")
});